import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ConsentState } from './consent.state';

export const selectConsentModule = createFeatureSelector<ConsentState>('consent');

export const selectConsent = createSelector(selectConsentModule, (state: ConsentState) => state.consent);
// ---------------------------------------------------------------------------------------------------------------------
export const selectEnableConsentAuth = createSelector(selectConsentModule, (state: ConsentState) => state.enableConsentAuth);
export const selectEnableConsentAuthAuthorization =
    createSelector(selectConsentModule, (state: ConsentState) => state.enableConsentAuth ? state.enableConsentAuth.authorization : null);
export const selectEnableConsentShown =
    createSelector(selectConsentModule, (state: ConsentState) => state.enableConsentAuth ? state.enableConsentAuth.shown : null);
// ---------------------------------------------------------------------------------------------------------------------
export const selectLoadingStatus = createSelector(selectConsentModule, (state: ConsentState) => state ? state.loadingStatus : null);
export const selectLoadingError = createSelector(selectConsentModule, (state: ConsentState) => state ? state.loadingError : null);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/consent/consent.selector.ts